// pages/lab/briefs/new.js
// ════════════════════════════════════════════════════════════════════
// Lab Briefs editor entry (Phase F14b). Client-only — uses
// localStorage for draft persistence.
// ════════════════════════════════════════════════════════════════════

import dynamic from 'next/dynamic';
import Head from 'next/head';

const BriefsEditor = dynamic(
  () => import('../../../features/briefs-editor/editor').then((m) => m.BriefsEditor),
  { ssr: false }
);

export default function NewBriefPage() {
  return (
    <div className="sp-root fe-page-root">
      <Head>
        <title>New Brief · Lab · Shift</title>
      </Head>
      <BriefsEditor />
    </div>
  );
}
